// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: 'ebde43d822449e864b8c2e1e8731a9aff2ebf1c2',
  hashShort: 'ebde43d'
};
